import React from "react";
import { Icon, type IconName } from "../Icon";

interface StatProps {
  label: string;
  value: React.ReactNode;
  unit?: string;
  delta?: React.ReactNode;
  deltaDir?: "up" | "down" | null;
  iconName?: IconName;
  span?: number;
  loading?: boolean;
}

export const Stat: React.FC<StatProps> = ({
  label,
  value,
  unit,
  delta,
  deltaDir,
  iconName,
  span,
  loading = false,
}) => (
  <div
    className="ds-stat"
    style={span != null ? { gridColumn: `span ${span}` } : undefined}
    data-span={span ?? undefined}
  >

    <div className="ds-stat-label">
      {iconName && <Icon name={iconName} size={12} />}
      {label}
    </div>
    <div className="ds-stat-value">
      {loading ? "–" : value}
      {unit && <span className="ds-unit">{unit}</span>}
    </div>
    {(delta || deltaDir) && (
      <div className={"ds-stat-delta" + (deltaDir ? " " + deltaDir : "")}>
        {deltaDir === "up" && "↑ "}
        {deltaDir === "down" && "↓ "}
        {delta}
      </div>
    )}
  </div>
);
